module.exports = __webpack_public_path__ + "6a4712cbea76a50d3648e88898e4d77e.jpg";